export const $domainSearchSettings = function() {
  var settings = {
    searchParams: {
      token: null,
      site: null,
      country: 'US'
    },
    source: 'google'
  };

  return settings;
};

$domainSearchSettings.$inject = [];
